const _ = require('lodash');

export const getKioskableValue = (isKiosk, config, valuePath, valuePathKiosk) =>
  isKiosk
    ? _.get(
      config,
      valuePathKiosk || `${valuePath}Kiosk`,
      _.get(config, valuePath))
    : _.get(config, valuePath);